export const ACCOUNT_TYPES = [
  ["developer", "Developer"], ["marketing_agency", "Marketing Agency"], ["marketing_agent", "Marketing Agent"],
  ["consultant", "Consultant"], ["individual", "Individual"],
];

export const accountTypeOf = (u) => u?.account_type || (u?.role === "marketing_agent" ? "marketing_agent" : "developer");
export const accountTypeLabel = (k) => (ACCOUNT_TYPES.find((t) => t[0] === k) || [k, k])[1];
